export const ErrorMessage = ({ text }: { text: string }) => {
  return <span className="text-xs text-jutro-new-rose-500">{text}</span>;
};
